import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    latestEarned: {
        isFetching: false,
        data: null
    },
    attributes: {
        isFetching: false,
        data: null
    },
    earned: {
        isFetching: false,
        data: null
    },
    available: {
        isFetching: false,
        data: null
    },
    comparison: {
        isFetching: false,
        data: null
    },
    leaderboard: {
        isFetching: false,
        isAppending: false,
        data: null,
        hasMoreDataToLoad: false
    }
};

// Latest Earned
const requestLatestEarnedBadges = (state) => {
    return {
        ...state,
        latestEarned: {
            ...state.latestEarned,
            isFetching: true
        }
    };
};

const receiveLatestEarnedBadges = (state, action) => {
    return {
        ...state,
        latestEarned: {
            isFetching: false,
            data: action.data,
            lastUpdated: action.receivedAt
        }
    };
};

// Badge Attributes
const requestBadgeAttributes = (state) => {
    return {
        ...state,
        attributes: {
            ...state.attributes,
            isFetching: true
        }
    };
};

const receiveBadgeAttributes = (state, action) => {
    return {
        ...state,
        attributes: {
            isFetching: false,
            data: action.data,
            lastUpdated: action.receivedAt
        }
    };
};

// Earned
const requestEarnedBadges = (state) => {
    return {
        ...state,
        earned: {
            ...state.earned,
            isFetching: true
        }
    };
};

const receiveEarnedBadges = (state, action) => {
    return {
        ...state,
        earned: {
            isFetching: false,
            data: action.data,
            lastUpdated: action.receivedAt
        }
    };
};

// Available
const requestAvailableBadges = (state) => {
    return {
        ...state,
        available: {
            ...state.available,
            isFetching: true
        }
    };
};

const receiveAvailableBadges = (state, action) => {
    return {
        ...state,
        available: {
            isFetching: false,
            data: action.data,
            lastUpdated: action.receivedAt
        }
    };
};

// Comparison
const requestComparisonBadges = (state) => {
    return {
        ...state,
        comparison: {
            ...state.comparison,
            isFetching: true
        }
    };
};

const receiveComparisonBadges = (state, action) => {
    return {
        ...state,
        comparison: {
            isFetching: false,
            data: action.data,
            lastUpdated: action.receivedAt
        }
    };
};

// Leaderboard
const requestBadgesLeaderboard = (state, action) => {
    return {
        ...state,
        leaderboard: {
            ...state.leaderboard,
            isFetching: true,
            isAppending: action.isAppending
        }
    };
};

const receiveBadgesLeaderboard = (state, action) => {
    let data;
    if (action.isAppending) {
        data = {
            ...state.leaderboard.data,
            connections: [...state.leaderboard.data.connections, ...action.data.connections]
        };
    } else {
        data = action.data;
    }

    return {
        ...state,
        leaderboard: {
            isFetching: false,
            isAppending: false,
            data,
            lastUpdated: action.receivedAt,
            hasMoreDataToLoad: state.leaderboard.data
                ? state.leaderboard.data.connections.length + action.data.connections.length <
                  state.leaderboard.data.publicConnectionCount + action.data.privateConnectionCount
                : action.data.connections.length <
                  action.data.publicConnectionCount + action.data.privateConnectionCount
        }
    };
};

const resetBadgesLeaderboard = (state) => ({
    ...state,
    leaderboard: {
        ...INITIAL_STATE.leaderboard
    }
});

const resetBadges = () => ({
    ...INITIAL_STATE
});

const handlers = {
    [types.REQUEST_LATEST_EARNED_BADGES]: requestLatestEarnedBadges,
    [types.RECEIVE_LATEST_EARNED_BADGES]: receiveLatestEarnedBadges,
    [types.FAILED_LATEST_EARNED_BADGES]: receiveLatestEarnedBadges,
    [types.REQUEST_BADGE_ATTRIBUTES]: requestBadgeAttributes,
    [types.RECEIVE_BADGE_ATTRIBUTES]: receiveBadgeAttributes,
    [types.FAILED_BADGE_ATTRIBUTES]: receiveBadgeAttributes,
    [types.REQUEST_EARNED_BADGES]: requestEarnedBadges,
    [types.RECEIVE_EARNED_BADGES]: receiveEarnedBadges,
    [types.FAILED_EARNED_BADGES]: receiveEarnedBadges,
    [types.REQUEST_AVAILABLE_BADGES]: requestAvailableBadges,
    [types.RECEIVE_AVAILABLE_BADGES]: receiveAvailableBadges,
    [types.FAILED_AVAILABLE_BADGES]: receiveAvailableBadges,
    [types.REQUEST_COMPARISON_BADGES]: requestComparisonBadges,
    [types.RECEIVE_COMPARISON_BADGES]: receiveComparisonBadges,
    [types.FAILED_COMPARISON_BADGES]: receiveComparisonBadges,
    [types.REQUEST_BADGES_LEADERBOARD]: requestBadgesLeaderboard,
    [types.RECEIVE_BADGES_LEADERBOARD]: receiveBadgesLeaderboard,
    [types.FAILED_BADGES_LEADERBOARD]: receiveBadgesLeaderboard,
    [types.RESET_BADGES_LEADERBOARD]: resetBadgesLeaderboard,
    [types.REQUEST_ACTIVITY_BADGES]: requestEarnedBadges,
    [types.RECEIVE_ACTIVITY_BADGES]: receiveEarnedBadges,
    [types.FAILED_ACTIVITY_BADGES]: receiveEarnedBadges,
    [types.REQUEST_DAILY_SUMMARY_BADGES]: requestEarnedBadges,
    [types.RECEIVE_DAILY_SUMMARY_BADGES]: receiveEarnedBadges,
    [types.FAILED_DAILY_SUMMARY_BADGES]: receiveEarnedBadges,
    [types.RESET_BADGES]: resetBadges
};

export const getBadges = (state) => {
    return state.badges;
};

export default function badges(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
